import { render, staticRenderFns } from "./DocumentacionGrid.vue?vue&type=template&id=6b138a09&scoped=true&"
import script from "./DocumentacionGrid.vue?vue&type=script&lang=js&"
export * from "./DocumentacionGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b138a09",
  null
  
)

/* custom blocks */
import block0 from "./DocumentacionGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports